import React from "react";
import ListTemplate, { ListTemplateRef } from "components/ListTemplate";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import NewBusinessCentralProject from "./NewBusinessCentralProject";
import { Modal } from "components";
import EditBusinessCentralProjectModalContent from "./EditBusinessCentralProjectModalContent";
import { useLoaderData } from "react-router";

const ProjectCodeListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BusinessCentralProjectListFrontModel>();

  const { colors } = serverReference.constants;

  const [editingProject, setEditingProject] = React.useState<server.dto.BusinessCentralProject>();

  const listRef = React.useRef<ListTemplateRef>();

  return <>
    <Modal
      isOpen={editingProject != null}
      handleClose={() => setEditingProject(undefined)}
      title={RESX.Buttons.btnEdit}
      width="tiny"
    >
      <EditBusinessCentralProjectModalContent
        editingProject={editingProject}
        onSaved={() => {
          setEditingProject(undefined);
          listRef.current.refetch();
        }}
      />
    </Modal>

    <div className="flex justify-end margin-bottom-bigger">
      <div>
        <NewBusinessCentralProject />
      </div>
    </div>
    <ListTemplate
      listRef={listRef}
      title={viewModel.pageTitle}
      filterSet="businessCentralProject_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.BusinessCentral.ListProjects}
      getId={item => +item.number}
      onEdit={item => setEditingProject(item)}
      layout={{
        type: "card",
        sections: {
          renderTitle: projectCode => <div>
            <div>
              <div className="table-main-link">{projectCode.name}</div>
            </div>
          </div>,
          renderBody: projectCode => <div>
            <div>
              {projectCode.number}
            </div>

            <div className="flex gap-small">
              <div>
                <i className="icon-circle" style={{ color: projectCode.visible ? colors.green : colors.red }} />
              </div>

              {projectCode.visible ? RESX.GeneralLabels.Visible : RESX.GeneralLabels.NotVisible}
            </div>
          </div>,
          renderFooter: () => <></>,
          hideFooter: () => true,
          hideTitle: () => false,

        }
      }}
      filters={<>
        <KeywordFilter placeholder={RESX.GeneralLabels.Keyword} />
        <VisibilityFilter />
      </>}
      functions={{
        mapResponseToFilterValues,
        mapFilterValuesToInstruction
      }}

    />
  </>;
};

export default ProjectCodeListApp;